/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UploadRouteImport } from './routes/upload'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ScreenRouteImport } from './routes/screen'
import { Route as PlacementsRouteImport } from './routes/placements'
import { Route as PipelineRouteImport } from './routes/pipeline'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InterviewsRouteImport } from './routes/interviews'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as AutomationRouteImport } from './routes/automation'
import { Route as AiUsageRouteImport } from './routes/ai-usage'
import { Route as IndexRouteImport } from './routes/index'
import { Route as JobsIndexRouteImport } from './routes/jobs.index'
import { Route as ClientsIndexRouteImport } from './routes/clients.index'
import { Route as CandidatesIndexRouteImport } from './routes/candidates.index'
import { Route as STokenRouteImport } from './routes/s.$token'
import { Route as JobsJobIdRouteImport } from './routes/jobs.$jobId'
import { Route as ClientsClientIdRouteImport } from './routes/clients.$clientId'
import { Route as CandidatesCandidateIdRouteImport } from './routes/candidates.$candidateId'
import { Route as CompareJobIdCandidateIdRouteImport } from './routes/compare.$jobId.$candidateId'

const UploadRoute = UploadRouteImport.update({
  id: '/upload',
  path: '/upload',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ScreenRoute = ScreenRouteImport.update({
  id: '/screen',
  path: '/screen',
  getParentRoute: () => rootRouteImport,
} as any)
const PlacementsRoute = PlacementsRouteImport.update({
  id: '/placements',
  path: '/placements',
  getParentRoute: () => rootRouteImport,
} as any)
const PipelineRoute = PipelineRouteImport.update({
  id: '/pipeline',
  path: '/pipeline',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InterviewsRoute = InterviewsRouteImport.update({
  id: '/interviews',
  path: '/interviews',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const AutomationRoute = AutomationRouteImport.update({
  id: '/automation',
  path: '/automation',
  getParentRoute: () => rootRouteImport,
} as any)
const AiUsageRoute = AiUsageRouteImport.update({
  id: '/ai-usage',
  path: '/ai-usage',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const JobsIndexRoute = JobsIndexRouteImport.update({
  id: '/jobs/',
  path: '/jobs/',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsIndexRoute = ClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => rootRouteImport,
} as any)
const CandidatesIndexRoute = CandidatesIndexRouteImport.update({
  id: '/candidates/',
  path: '/candidates/',
  getParentRoute: () => rootRouteImport,
} as any)
const STokenRoute = STokenRouteImport.update({
  id: '/s/$token',
  path: '/s/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const JobsJobIdRoute = JobsJobIdRouteImport.update({
  id: '/jobs/$jobId',
  path: '/jobs/$jobId',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsClientIdRoute = ClientsClientIdRouteImport.update({
  id: '/clients/$clientId',
  path: '/clients/$clientId',
  getParentRoute: () => rootRouteImport,
} as any)
const CandidatesCandidateIdRoute = CandidatesCandidateIdRouteImport.update({
  id: '/candidates/$candidateId',
  path: '/candidates/$candidateId',
  getParentRoute: () => rootRouteImport,
} as any)
const CompareJobIdCandidateIdRoute = CompareJobIdCandidateIdRouteImport.update({
  id: '/compare/$jobId/$candidateId',
  path: '/compare/$jobId/$candidateId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/ai-usage': typeof AiUsageRoute
  '/automation': typeof AutomationRoute
  '/dashboard': typeof DashboardRoute
  '/interviews': typeof InterviewsRoute
  '/login': typeof LoginRoute
  '/pipeline': typeof PipelineRoute
  '/placements': typeof PlacementsRoute
  '/screen': typeof ScreenRoute
  '/settings': typeof SettingsRoute
  '/upload': typeof UploadRoute
  '/candidates/$candidateId': typeof CandidatesCandidateIdRoute
  '/clients/$clientId': typeof ClientsClientIdRoute
  '/jobs/$jobId': typeof JobsJobIdRoute
  '/s/$token': typeof STokenRoute
  '/candidates/': typeof CandidatesIndexRoute
  '/clients/': typeof ClientsIndexRoute
  '/jobs/': typeof JobsIndexRoute
  '/compare/$jobId/$candidateId': typeof CompareJobIdCandidateIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/ai-usage': typeof AiUsageRoute
  '/automation': typeof AutomationRoute
  '/dashboard': typeof DashboardRoute
  '/interviews': typeof InterviewsRoute
  '/login': typeof LoginRoute
  '/pipeline': typeof PipelineRoute
  '/placements': typeof PlacementsRoute
  '/screen': typeof ScreenRoute
  '/settings': typeof SettingsRoute
  '/upload': typeof UploadRoute
  '/candidates/$candidateId': typeof CandidatesCandidateIdRoute
  '/clients/$clientId': typeof ClientsClientIdRoute
  '/jobs/$jobId': typeof JobsJobIdRoute
  '/s/$token': typeof STokenRoute
  '/candidates': typeof CandidatesIndexRoute
  '/clients': typeof ClientsIndexRoute
  '/jobs': typeof JobsIndexRoute
  '/compare/$jobId/$candidateId': typeof CompareJobIdCandidateIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/ai-usage': typeof AiUsageRoute
  '/automation': typeof AutomationRoute
  '/dashboard': typeof DashboardRoute
  '/interviews': typeof InterviewsRoute
  '/login': typeof LoginRoute
  '/pipeline': typeof PipelineRoute
  '/placements': typeof PlacementsRoute
  '/screen': typeof ScreenRoute
  '/settings': typeof SettingsRoute
  '/upload': typeof UploadRoute
  '/candidates/$candidateId': typeof CandidatesCandidateIdRoute
  '/clients/$clientId': typeof ClientsClientIdRoute
  '/jobs/$jobId': typeof JobsJobIdRoute
  '/s/$token': typeof STokenRoute
  '/candidates/': typeof CandidatesIndexRoute
  '/clients/': typeof ClientsIndexRoute
  '/jobs/': typeof JobsIndexRoute
  '/compare/$jobId/$candidateId': typeof CompareJobIdCandidateIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/ai-usage'
    | '/automation'
    | '/dashboard'
    | '/interviews'
    | '/login'
    | '/pipeline'
    | '/placements'
    | '/screen'
    | '/settings'
    | '/upload'
    | '/candidates/$candidateId'
    | '/clients/$clientId'
    | '/jobs/$jobId'
    | '/s/$token'
    | '/candidates/'
    | '/clients/'
    | '/jobs/'
    | '/compare/$jobId/$candidateId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/ai-usage'
    | '/automation'
    | '/dashboard'
    | '/interviews'
    | '/login'
    | '/pipeline'
    | '/placements'
    | '/screen'
    | '/settings'
    | '/upload'
    | '/candidates/$candidateId'
    | '/clients/$clientId'
    | '/jobs/$jobId'
    | '/s/$token'
    | '/candidates'
    | '/clients'
    | '/jobs'
    | '/compare/$jobId/$candidateId'
  id:
    | '__root__'
    | '/'
    | '/ai-usage'
    | '/automation'
    | '/dashboard'
    | '/interviews'
    | '/login'
    | '/pipeline'
    | '/placements'
    | '/screen'
    | '/settings'
    | '/upload'
    | '/candidates/$candidateId'
    | '/clients/$clientId'
    | '/jobs/$jobId'
    | '/s/$token'
    | '/candidates/'
    | '/clients/'
    | '/jobs/'
    | '/compare/$jobId/$candidateId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AiUsageRoute: typeof AiUsageRoute
  AutomationRoute: typeof AutomationRoute
  DashboardRoute: typeof DashboardRoute
  InterviewsRoute: typeof InterviewsRoute
  LoginRoute: typeof LoginRoute
  PipelineRoute: typeof PipelineRoute
  PlacementsRoute: typeof PlacementsRoute
  ScreenRoute: typeof ScreenRoute
  SettingsRoute: typeof SettingsRoute
  UploadRoute: typeof UploadRoute
  CandidatesCandidateIdRoute: typeof CandidatesCandidateIdRoute
  ClientsClientIdRoute: typeof ClientsClientIdRoute
  JobsJobIdRoute: typeof JobsJobIdRoute
  STokenRoute: typeof STokenRoute
  CandidatesIndexRoute: typeof CandidatesIndexRoute
  ClientsIndexRoute: typeof ClientsIndexRoute
  JobsIndexRoute: typeof JobsIndexRoute
  CompareJobIdCandidateIdRoute: typeof CompareJobIdCandidateIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/upload': {
      id: '/upload'
      path: '/upload'
      fullPath: '/upload'
      preLoaderRoute: typeof UploadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/screen': {
      id: '/screen'
      path: '/screen'
      fullPath: '/screen'
      preLoaderRoute: typeof ScreenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/placements': {
      id: '/placements'
      path: '/placements'
      fullPath: '/placements'
      preLoaderRoute: typeof PlacementsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pipeline': {
      id: '/pipeline'
      path: '/pipeline'
      fullPath: '/pipeline'
      preLoaderRoute: typeof PipelineRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/interviews': {
      id: '/interviews'
      path: '/interviews'
      fullPath: '/interviews'
      preLoaderRoute: typeof InterviewsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/automation': {
      id: '/automation'
      path: '/automation'
      fullPath: '/automation'
      preLoaderRoute: typeof AutomationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ai-usage': {
      id: '/ai-usage'
      path: '/ai-usage'
      fullPath: '/ai-usage'
      preLoaderRoute: typeof AiUsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jobs/': {
      id: '/jobs/'
      path: '/jobs'
      fullPath: '/jobs/'
      preLoaderRoute: typeof JobsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients/': {
      id: '/clients/'
      path: '/clients'
      fullPath: '/clients/'
      preLoaderRoute: typeof ClientsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/candidates/': {
      id: '/candidates/'
      path: '/candidates'
      fullPath: '/candidates/'
      preLoaderRoute: typeof CandidatesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/s/$token': {
      id: '/s/$token'
      path: '/s/$token'
      fullPath: '/s/$token'
      preLoaderRoute: typeof STokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jobs/$jobId': {
      id: '/jobs/$jobId'
      path: '/jobs/$jobId'
      fullPath: '/jobs/$jobId'
      preLoaderRoute: typeof JobsJobIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients/$clientId': {
      id: '/clients/$clientId'
      path: '/clients/$clientId'
      fullPath: '/clients/$clientId'
      preLoaderRoute: typeof ClientsClientIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/candidates/$candidateId': {
      id: '/candidates/$candidateId'
      path: '/candidates/$candidateId'
      fullPath: '/candidates/$candidateId'
      preLoaderRoute: typeof CandidatesCandidateIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compare/$jobId/$candidateId': {
      id: '/compare/$jobId/$candidateId'
      path: '/compare/$jobId/$candidateId'
      fullPath: '/compare/$jobId/$candidateId'
      preLoaderRoute: typeof CompareJobIdCandidateIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AiUsageRoute: AiUsageRoute,
  AutomationRoute: AutomationRoute,
  DashboardRoute: DashboardRoute,
  InterviewsRoute: InterviewsRoute,
  LoginRoute: LoginRoute,
  PipelineRoute: PipelineRoute,
  PlacementsRoute: PlacementsRoute,
  ScreenRoute: ScreenRoute,
  SettingsRoute: SettingsRoute,
  UploadRoute: UploadRoute,
  CandidatesCandidateIdRoute: CandidatesCandidateIdRoute,
  ClientsClientIdRoute: ClientsClientIdRoute,
  JobsJobIdRoute: JobsJobIdRoute,
  STokenRoute: STokenRoute,
  CandidatesIndexRoute: CandidatesIndexRoute,
  ClientsIndexRoute: ClientsIndexRoute,
  JobsIndexRoute: JobsIndexRoute,
  CompareJobIdCandidateIdRoute: CompareJobIdCandidateIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
